import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import useProfileSx from '../../hooks/useProfileSx';

export default function PermissionCheckboxCell({
  checked = false,
  disabled = false,
  inactive = false,
  onChange,
}) {
  const sx = useProfileSx();

  if (inactive) {
    return (
      <Box sx={sx.permissionMatrixCell}>
        <Typography variant="body2" sx={sx.permissionMatrixInactive}>
          —
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={sx.permissionMatrixCell}>
      <Checkbox
        size="small"
        checked={Boolean(checked)}
        disabled={disabled}
        onChange={(event) => onChange?.(event.target.checked)}
        sx={sx.permissionMatrixCheckbox}
      />
      <Typography
        variant="body2"
        sx={checked ? sx.permissionMatrixYes : sx.permissionMatrixNo}
      >
        {checked ? 'Yes' : 'No'}
      </Typography>
    </Box>
  );
}
